import React from "react";

import { Outlet } from "react-router-dom";

const CustomersTemplate = () => {

  return (
    <Outlet />
  );
}

export default CustomersTemplate;